import { environment } from '../environments/environment';

export function loadRuntimeConfig() {
    // dev-setup writes /assets/config.json to retarget the compiled API URLs for a second clone.
    // Gated to the development build (environment.runtimeConfig) so compiled prod/stage/qae/devcloud
    // bundles never fetch a host page's /assets/config.json. Mutates `environment` IN PLACE so every
    // config token (all useValue this same reference) sees it.
    return async (): Promise<void> => {
        if (!environment.runtimeConfig) return;
        try {
            const res = await fetch('/assets/config.json', { cache: 'no-store' });
            if (!res.ok) {
                // eslint-disable-next-line no-console
                console.warn(`[runtime-config] /assets/config.json ${res.status}; keeping compiled defaults`);
                return;
            }
            const overrides = await res.json();
            const picked: Partial<typeof environment> = {};
            for (const key of ['apiUrl', 'loginApiUrl', 'loginApiUrlInternal', 'uiUrl'] as const) {
                if (typeof overrides?.[key] === 'string') picked[key] = overrides[key];
            }
            Object.assign(environment, picked);
        } catch (err) {
            // eslint-disable-next-line no-console
            console.warn('[runtime-config] config.json not applied; keeping compiled defaults', err);
        }
    };
}
